import { cn } from "@/modern/utils";
import { EntityFinderHighlight } from "@/modern/components/entity-finder/components/EntityFinderHighlight";
import { EntityFinderMetaBadge } from "@/modern/components/entity-finder/components/EntityFinderMetaBadge";
import {
  ENTITY_FINDER_SUBTITLE_CLS,
  ENTITY_FINDER_TITLE_CLS,
} from "@/modern/components/entity-finder/constants/layout";
import { entityFinderRowClass } from "@/modern/components/entity-finder/components/EntityFinderItemRow";
import type { SettingItemRecord } from "@/modern/components/entity-finder/types";
import type { EntityFinderItem } from "@/modern/components/entity-finder/types";

interface EntityFinderSettingRowProps {
  item: EntityFinderItem;
  query?: string;
  className?: string;
}

function ScopeBadge({ scope }: { scope: SettingItemRecord["subcategory"]["settingScope"] }) {
  if (!scope) return null;

  return (
    <EntityFinderMetaBadge variant={scope === "personal" ? "personal" : "board"}>
      {scope === "personal" ? "Personal" : "Board-wide"}
    </EntityFinderMetaBadge>
  );
}

export function EntityFinderSettingRow({ item, query = "", className }: EntityFinderSettingRowProps) {
  const record = item.record as SettingItemRecord;
  const hasSubtitle = Boolean(item.subtitle);

  return (
    <div className={cn(entityFinderRowClass(hasSubtitle), className)}>
      <div
        className={cn(
          "flex size-8 shrink-0 items-center justify-center rounded-md ring-1 ring-border/60 shadow-sm bg-chart-4/20 text-chart-4",
          hasSubtitle && "mt-0.5"
        )}
      >
        <i className={cn(record.category.icon, "text-sm")} />
      </div>
      <div className="min-w-0 flex-1">
        <div className={cn("truncate", ENTITY_FINDER_TITLE_CLS)}>
          <EntityFinderHighlight text={item.label} query={query} />
        </div>
        {item.subtitle ? (
          <p className={cn("mt-0.5 truncate", ENTITY_FINDER_SUBTITLE_CLS)}>
            <EntityFinderHighlight text={item.subtitle} query={query} tone="muted" />
          </p>
        ) : null}
      </div>
      <div className={cn("shrink-0", hasSubtitle && "mt-0.5")}>
        <ScopeBadge scope={record.subcategory.settingScope} />
      </div>
    </div>
  );
}
